const API_RESPONSE_CODE = {
  SUCCESS: 200,
  REDIRECT_FOUND: 302,
  NOT_MODIFIED: 304,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_ERROR: 500
}

const API_RESPONSE_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  FAIL: 'fail'
}

const API_BODY_SUCCESS = {
  status: API_RESPONSE_STATUS.SUCCESS,
  data: {},
  code: API_RESPONSE_CODE.SUCCESS
}

const API_BODY_ERROR = {
  status: API_RESPONSE_STATUS.ERROR,
  message: 'Bad request',
  code: API_RESPONSE_CODE.BAD_REQUEST
}

const API_RESPONSE_KEY = {
  STATUS: 'status',
  DATA: 'data',
  EXTRA_DATA: 'extraData',
  ERROR: 'status',
  MESSAGE: 'message',
  CODE: 'code'
}

export {
  API_RESPONSE_KEY,
  API_RESPONSE_CODE,
  API_RESPONSE_STATUS,
  API_BODY_SUCCESS,
  API_BODY_ERROR
}
